import { render, staticRenderFns } from "./StoreUserShops.vue?vue&type=template&id=4b437070"
import script from "./StoreUserShops.vue?vue&type=script&lang=js"
export * from "./StoreUserShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports